import {Component, EventEmitter, OnInit, Output, ViewChild} from '@angular/core';
import {ModalComponent} from 'src/app/common/calculator-modal/modal/modal.component';
import {CalculatorServices} from 'src/app/Services/calculator.service';

declare var $: any;
@Component({
    selector: 'app-calculator-widget',
    templateUrl: './calculator-widget.component.html',
    styleUrls: ['./calculator-widget.component.scss']
})

export class CalculatorWidgetComponent implements OnInit{
   @Output() modal: EventEmitter<boolean> = new EventEmitter();
   @ViewChild(ModalComponent, {static: true}) modalVisible: ModalComponent;
   validation: boolean = false;
   filter: any = {advance: false};
    constructor(private calculatorService: CalculatorServices){
    }
    ngOnInit(): void {
        this.calculatorService.change.subscribe(isOpen => {this.validation = isOpen});
    }
    closeModal(event){
        this.modal.emit(!event)
    }

    showAdvance() {
        this.filter.advance = !this.filter.advance;
        $('.openOption').slideToggle({
            start() {
                $(this).css('display', 'block');
                $(this).css('margin', '5px');
            }
        });
    }
}
